import { createRouter, createWebHistory } from 'vue-router'
import { session } from './composables/useSession'
import LoginView from './views/LoginView.vue'
import DashboardView from './views/DashboardView.vue'
import BookingsView from './views/BookingsView.vue'
import ResourcesView from './views/ResourcesView.vue'
import CalendarView from './views/CalendarView.vue'
import InquiriesView from './views/InquiriesView.vue'
import UsersView from './views/UsersView.vue'
import CatalogView from './views/CatalogView.vue'
import SalesView from './views/SalesView.vue'
import { routeRedirect } from './api/users'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/', name: 'dashboard', component: DashboardView },
    { path: '/bookings', name: 'bookings', component: BookingsView },
    { path: '/inquiries', name: 'inquiries', component: InquiriesView, meta: { adminOnly: true } },
    { path: '/resources', name: 'resources', component: ResourcesView },
    { path: '/calendar', name: 'calendar', component: CalendarView },
    { path: '/users', name: 'users', component: UsersView, meta: { adminOnly: true } },
    { path: '/services', name: 'services', component: CatalogView, props: { kind: 'service' }, meta: { adminOnly: true } },
    { path: '/products', name: 'products', component: CatalogView, props: { kind: 'product' }, meta: { adminOnly: true } },
    { path: '/sales', name: 'sales', component: SalesView, meta: { adminOnly: true } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  if (!session.ready) {
    await session.restore()
  }

  return routeRedirect(to, session.user)
})

export default router
